import script from "./Order_component.vue?vue&type=script&setup=true&lang=js"
export * from "./Order_component.vue?vue&type=script&setup=true&lang=js"

import "./Order_component.vue?vue&type=style&index=0&id=6af89531&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af89531"]])

export default __exports__